export const VAMethodology = `VerificationMethodology/`;
export const VAMethodologySearch = VAMethodology + 'Search';
export const VAMethodologyInclude = VAMethodology + 'Include';
export const VAMethodologyDelete = VAMethodology + 'Delete';
export const VAMethodologySortOrder = VAMethodology + 'SortOrder';
export const VAMethodologyCreate = VAMethodology + 'SaveEntry';